module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section-padding8 section",
    staticStyle: {
      "background": "#eaeff2"
    }
  }, [_c('div', {
    staticClass: "jiashangyigegao",
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80%",
      "margin-left": "12%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "yingyongfenlei",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("右滑查看更多分类->")]), _vm._v(" "), _c('div', {
    staticClass: "search_sun wow fadeInLeft animated",
    staticStyle: {
      "animation-duration": "0.7s",
      "animation-delay": "0.2s"
    }
  }, [_c('ul', _vm._l((_vm.hangyelist), function(item, index) {
    return (item == _vm.xuanzhong) ? _c('li', {
      key: index,
      staticStyle: {
        "background": "#4ec2bf",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          return _vm.hangyexz(item)
        }
      }
    }, [_c('i', {
      class: 'biaoqian biaoqian' + index
    }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(item) + "\n              ")])]) : _c('li', {
      on: {
        "click": function($event) {
          return _vm.hangyexz(item)
        }
      }
    }, [_c('i', {
      class: 'biaoqian biaoqian' + index
    }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(item) + "\n              ")])])
  }), 0)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "yingyongfenlei",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("右滑查看更多分类->")]), _vm._v(" "), _c('div', {
    staticClass: "search_sun2 wow fadeInLeft animated",
    staticStyle: {
      "animation-duration": "0.7s",
      "animation-delay": "0.3s"
    }
  }, [_c('div', [_c('ul', [(_vm.fenleixz == 7) ? _c('li', {
    staticStyle: {
      "background": "#4ec2bf",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        return _vm.fenlei(7)
      }
    }
  }, [_c('p', [_vm._v("全部")]), _vm._v(" "), _c('p', [_vm._v("All")])]) : _c('li', {
    on: {
      "click": function($event) {
        return _vm.fenlei(7)
      }
    }
  }, [_c('p', [_vm._v("全部")]), _vm._v(" "), _c('p', [_vm._v("All")])]), _vm._v(" "), _vm._l((_vm.cplist), function(item, index) {
    return (item.scode == _vm.fenleixz) ? _c('li', {
      key: index,
      staticStyle: {
        "background": "#4ec2bf",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          return _vm.fenlei(item.scode)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.subname))])]) : _c('li', {
      on: {
        "click": function($event) {
          return _vm.fenlei(item.scode)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.subname))])])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chanpin_s1_hy"
  }, [_vm._l((_vm.prductlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chanpin_s2_01 wow zoomIn animated",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "0.3s"
      }
    }, [_c('a', {
      attrs: {
        "href": '/chanpin?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "chanpin_s101_a_hy"
    }, [_c('div', {
      staticClass: "chanpin_s101_a22"
    }, [_c('img', {
      attrs: {
        "src": _vm.newurl + item.ico
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "chanpin_s101_a23",
      staticStyle: {
        "height": "180px",
        "overflow": "hidden"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "18px",
        "color": "#4ec2bf"
      }
    }, [_vm._v(_vm._s(item.ext_c2))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#718096"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.truncatecontent(item.ext_xingneng))
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "color": "#666666",
        "width": "100%",
        "text-align": "center",
        "line-height": "60px"
      }
    }, [_vm._v(_vm._s(item.title) + "\n          ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "hy_fenye"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.fanye(1)
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _vm._l((_vm.countsum), function(n) {
    return (n == _vm.issum) ? _c('span', {
      key: n,
      staticClass: "hy_xz",
      on: {
        "click": function($event) {
          return _vm.fanye(n)
        }
      }
    }, [_vm._v("\n        " + _vm._s(n) + "\n      ")]) : _c('span', {
      on: {
        "click": function($event) {
          return _vm.fanye(n)
        }
      }
    }, [_vm._v("\n        " + _vm._s(n) + "\n      ")])
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.issum) + "/" + _vm._s(_vm.countsum))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.fanye(_vm.countsum)
      }
    }
  }, [_vm._v("尾页")])], 2)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding hangye_section1 section",
    staticStyle: {
      "height": "960px"
    }
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("行业应用")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "0.8s",
      "animation-delay": "0.5s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v("INDUSTRY\n        APPLICATIONS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wow fadeInDown40 animated geiniyig",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s",
      "width": "100%",
      "text-align": "center",
      "padding": "50px 0px"
    }
  }, [_c('p'), _c('h3', {
    staticClass: "yingyongziti"
  }, [_vm._v("请尝试在所属行业中搜索您要查找的产品")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "yingyongziti2"
  }, [_vm._v(" Please try searching for the product you are looking for in your industry")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wow fadeInDown40 animated anleibiece geiniyig",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s",
      "width": "100%",
      "text-align": "center",
      "padding": "50px 0px",
      "margin-top": "50px"
    }
  }, [_c('p'), _c('h3', {
    staticClass: "yingyongziti"
  }, [_vm._v("按类别筛选")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "yingyongziti2"
  }, [_vm._v("Choose category")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b668a5d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Yingyong.vue
// module id = 117
// module chunks = 0